// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_1s83P","arrow":"_18lRU","page":"_3lcl7","active":"_18kCY"};